import React from 'react';
import { PaymentForm, CreditCard } from 'react-square-web-payments-sdk';

const SquareCheckout = props => {
  const {
    applicationId,
    locationId
  } = props;

  return (
    <PaymentForm
      applicationId={applicationId}
      locationId={locationId}
      cardTokenizeResponseReceived={(token, verifiedBuyer) => {
	console.log(token, verifiedBuyer);
      }}
    >
      <CreditCard />
    </PaymentForm>
  );
};

export default SquareCheckout;
